import { useFrame, useLoader } from "@react-three/fiber";
import { useEffect, useRef } from "react";
import { TextureLoader } from "three";
import { useStore } from "../store";
import * as THREE from "three";

function MemberCircle(props) {
  const colorMap = useLoader(
    TextureLoader,
    props.isMember ? props.img : "/assets/images/empty.png"
  );
  const alphaMap = useLoader(TextureLoader, "/assets/images/alphamap.png");
  const scale = 1,
    mesh = useRef(),
    mat = useRef();
  const setQuery = useStore((state) => state.setQuery);
  const setVisibility = useStore((state) => state.setResultVisible);
  let position = props.position;
  let opacity = props.opacity;

  // [설정/플로팅] 멤버 서클이 올라가는 속도 조절
  const floatingSpeedBase = 0.01;
  const floatingSpeedRandom = Math.random() * 0.01;
  const floatingBound = 40;

  const onClick = () => {
    if (!props.name | (props.name === "")) return;

    setQuery({ type: "id", token: props.num });
    setVisibility(true);
  };
  useFrame((state, delta) => {
    if (props.isFloating) {
      mat.current.opacity = 1 - Math.max(mesh.current.position.y - 30, 0) / 10; // 높이 y가 30 이상일 때 opacity가 1에서 0으로 줄어든다.
      mesh.current.position.y += floatingSpeedBase + floatingSpeedRandom; // 서클이 올라감
      if (mesh.current.position.y > floatingBound)
        // 반복을 위해서 높이가 +n 초과일 때 -n으로 변경
        mesh.current.position.y *= -1;
    } else {
      if (opacity < 1) opacity += 0.01;
      mat.current.opacity = opacity;
    }
  });

  useEffect(() => {
    if (props.isDirected) mesh.current.lookAt(props.center);
  });

  return props.isMember ? (
    <mesh
      ref={mesh}
      scale={scale}
      position={[position.x, position.y, position.z]}
      onClick={(e) => onClick(e)}
    >
      <circleGeometry args={[0.5, 32]} />
      <meshBasicMaterial
        ref={mat}
        map={colorMap}
        transparent={true}
        opacity={1}
        side={THREE.DoubleSide}
        alphaMap={alphaMap}
      />
    </mesh>
  ) : (
    <mesh
      ref={mesh}
      scale={scale}
      position={[position.x, position.y, position.z]}
    >
      <circleGeometry args={[0.5, 32]} />
      <meshBasicMaterial
        ref={mat}
        map={colorMap}
        transparent={true}
        opacity={1}
        side={THREE.DoubleSide}
        alphaMap={alphaMap}
      />
    </mesh>
  );
}

export default MemberCircle;
